import { useRef, useState } from "react";
import { Upload } from "lucide-react";

const ACCEPT = ".jpg,.jpeg,.png,.webp,.mp4,.mov,.webm";

export const Dropzone = ({ onFile, disabled }) => {
  const input = useRef(null);
  const [over, setOver] = useState(false);

  const drop = (e) => {
    e.preventDefault();
    setOver(false);
    if (!disabled && e.dataTransfer.files?.[0]) onFile(e.dataTransfer.files[0]);
  };

  return (
    <div
      onClick={() => !disabled && input.current?.click()}
      onDragOver={(e) => { e.preventDefault(); setOver(true); }}
      onDragLeave={() => setOver(false)}
      onDrop={drop}
      className={`border border-dashed cursor-pointer p-8 sm:p-10 transition-colors duration-150 ${over ? "border-[var(--rf-red)] bg-[var(--rf-soft)]" : "border-[var(--rf-ink)] hover:bg-[var(--rf-soft)]"}`}
      data-testid="media-upload-dropzone"
    >
      <Upload size={22} strokeWidth={1.5} className={over ? "rf-red" : ""} />
      <p className="mt-8 text-2xl font-bold tracking-tight">Trascina qui un'immagine o un video</p>
      <p className="mt-2 text-sm text-[var(--rf-grey)]">oppure clicca per selezionarlo dal dispositivo</p>
      <p className="mt-8 rf-mono text-[10px] tracking-[0.2em] uppercase text-[var(--rf-grey)]">
        JPG · PNG · WEBP fino a 20 MB — MP4 · MOV · WEBM fino a 100 MB
      </p>
      <input ref={input} type="file" accept={ACCEPT} className="hidden" data-testid="media-file-input"
        onChange={(e) => { if (e.target.files?.[0]) onFile(e.target.files[0]); e.target.value = ""; }} />
    </div>
  );
};
